import React, { useEffect } from "react";
import { Router, useNavigate, Navigate } from "react-router-dom";
import { Route, Routes } from "react-router-dom";

// JS Files
import Homepage from "./components/homepage/Homepage";
import Record from "./components/record/Record";
import Followup from "./components/followup/Followup";
import Rules from "./components/rules/Rules";
import Notifications from "./components/notifications/Notifications";
import NotificationsDetails from "./components/notifications/NotificationsDetails";
import Contactus from "./components/contactus/Contactus";
import Aboutus from "./components/aboutus/Aboutus";
import Questions from "./components/questions/Questions";
import Centers from "./components/centers/Centers";
import Policy from "./components/policy/Policy";
import SignupTakmili from "./components/darman-takmili/signup/SignupTakmili";
import FollowupTakmili from "./components/darman-takmili/followup/FollowupTakmili";

const UnAuthenticated = () => {
  return (
    <>
      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="*" element={<Navigate to="/" replace />} />

        <Route path="/record/:type" element={<Record />} />
        <Route path="/follow-up/:type" element={<Followup />} />
        <Route path="/rules" element={<Rules />} />
        <Route path="/policy" element={<Policy />} />
        <Route path="/notifications" element={<Notifications />} />
        <Route
          path="/notifications-details/:id"
          element={<NotificationsDetails />}
        />
        <Route path="/contactus" element={<Contactus />} />
        <Route path="/aboutus" element={<Aboutus />} />
        <Route path="/questions" element={<Questions />} />
        <Route path="/centers/:province/:city" element={<Centers />} />
        <Route path="/darman-takmili-signup" element={<SignupTakmili />} />
        <Route path="/follow-up-takmili" element={<FollowupTakmili />} />
      </Routes>
    </>
  );
};
export default UnAuthenticated;
